import { SessionReadParams } from 'types/session';

export const LOGIN_INITIAL_VALUES: SessionReadParams = {
    username: '',
    password: '',
};
